import { CircleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';

export const invalidFieldClassName =
  'border-red-300 text-red-600 shadow-none focus:ring-red-400 focus-visible:ring-red-400';

export const fieldErrorMessageClassName = 'text-xs font-normal leading-4 text-red-600';

export function FieldErrorIcon({ className }: { className?: string }) {
  return (
    <CircleAlert
      aria-hidden="true"
      className={cn('pointer-events-none h-4 w-4 shrink-0 fill-red-500 text-white', className)}
    />
  );
}
